// Tab, LF and CR are the only C0 characters XML 1.0 permits; the rest make the document unparseable.
// eslint-disable-next-line no-control-regex
const FORBIDDEN_CONTROL_CHARS = /[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g;

const stripControlChars = (value: string): string =>
  value.replace(FORBIDDEN_CONTROL_CHARS, '');

export default stripControlChars;
